import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/axiosInstance"; // Import axiosInstance

// Async Thunk to fetch attributes
export const fetchAttributes = createAsyncThunk(
  "attributes/fetchAttributes",
  async (slugs, { rejectWithValue }) => {
    try {
      // Ensure slugs is an array, and convert to a comma-separated string
      const categoryParam = Array.isArray(slugs) ? slugs.join(",") : slugs;

      const response = await axiosInstance.get(`/api/website/attributes`, {
        params: { category: categoryParam },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch attributes");
    }
  }
);


// Attribute slice
const attributeSlice = createSlice({
  name: "attributes",
  initialState: {
    attributes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.attributes = action.payload.data; // Map the data to attributes
      })
      .addCase(fetchAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default attributeSlice.reducer;
